import React from 'react';
import SeoLandingPage, { SeoLandingContent } from './SeoLandingPage';

const content: SeoLandingContent = {
  path: '/lawn-care-scheduling-software',
  title: 'Lawn Care Scheduling Software | LawnHub',
  description:
    'Lawn care scheduling software for growing crews. Plan routes, assign jobs, and keep customers on schedule — without a forced monthly subscription.',
  keywords:
    'lawn care scheduling software, lawn care schedule app, landscaping scheduling software, snow removal scheduling, crew scheduling lawn care',
  h1: 'Lawn Care Scheduling Software That Actually Fits Your Day',
  subhead:
    'LawnHub helps lawn care and snow removal businesses schedule jobs, optimize routes, and keep crews moving — so you spend less time in the office and more time earning.',
  sections: [
    {
      heading: 'Stop juggling spreadsheets and text threads',
      body: 'Most lawn care owners start with a calendar and a group chat. That works until you have multiple crews, seasonal contracts, and weather delays. LawnHub puts scheduling, customer jobs, and crew visibility in one place so everyone knows what is next.',
      bullets: [
        'Build and adjust daily routes as jobs complete',
        'Keep recurring lawn and seasonal services on track',
        'Give crews a clear mobile view of today’s work',
        'Reduce missed visits and double-bookings',
      ],
    },
    {
      heading: 'Scheduling plus the ops tools around it',
      body: 'Scheduling only helps if payments, customers, and follow-ups live nearby. LawnHub connects scheduling to CRM, payments, Additional Services estimates, and optional crew time tracking — so your schedule is the center of the business, not another silo.',
      bullets: [
        'Customer profiles and service history next to the schedule',
        'Automated customer payments after completed work',
        'Route optimization to cut drive time and fuel',
        'Works for lawn care and snow removal seasons',
      ],
    },
    {
      heading: 'Fair pricing for operators, not another SaaS tax',
      body: 'Many scheduling tools lock features behind monthly tiers. LawnHub is built around completed work: no forced subscription to access your own customers. Bring your book at 1%, and use marketplace leads when you want growth.',
    },
  ],
  faq: [
    {
      q: 'Is LawnHub lawn care scheduling software or just a lead marketplace?',
      a: 'Both. You can run full scheduling, CRM, crews, and payments for customers you already have — and optionally bid on marketplace requests when you want new work.',
    },
    {
      q: 'Can crews see the schedule on their phones?',
      a: 'Yes. Crews use a mobile workflow for assigned routes and job completion so field teams stay aligned with the office schedule.',
    },
    {
      q: 'Does scheduling work for snow removal too?',
      a: 'Yes. LawnHub supports lawn care and snow removal operations so seasonal businesses are not forced into separate tools.',
    },
  ],
  relatedLinks: [
    { label: 'Lawn care CRM', to: '/lawn-care-crm' },
    { label: 'Jobber alternative', to: '/jobber-alternative' },
    { label: 'Provider benefits', to: '/provider-benefits' },
    { label: 'About LawnHub', to: '/about-us' },
  ],
};

const LawnCareSchedulingSoftwarePage: React.FC = () => <SeoLandingPage content={content} />;

export default LawnCareSchedulingSoftwarePage;
